import styles from './Specs.module.scss'

import React, { Fragment } from 'react'

import disallowedProductCardSpecs from 'Constants/DisallowedProductCardSpecs'

import Typography from 'Atoms/Typography'

const Specs = ({ productSpecs, className, setHasSpecs }) => {
  if (!productSpecs) {
    return false
  }
  const GetKeySpecs = () => {
    return productSpecs
      .filter((spec) => spec.isKeySpec && !disallowedProductCardSpecs.some((x) => x === spec.title))
      .sort((a, b) => a.ordinality - b.ordinality)
      .slice(0, 3)
  }

  const keySpecs = GetKeySpecs()

  if (!keySpecs?.length) {
    return false
  }

  setHasSpecs(true)

  return (
    <>
      <span className={className}>
        {keySpecs.slice(0, 3).map((spec, i) => {
          return (
            <Fragment key={`spec-${spec.title}-${i}`}>
              <Typography size={0.875} className={styles.title} inline>
                {`${spec.title}: `}
              </Typography>
              <Typography size={0.875} className={styles.value} font={'bold'} inline>
                {spec.value}
              </Typography>
              <br />
            </Fragment>
          )
        })}
      </span>
    </>
  )
}

export default Specs
